export default {
  login: 'ShIKULJAK',
  id: 75026773,
  node_id: 'MDQ6VXNlcjc1MDI2Nzcz',
  avatar_url: 'https://avatars.githubusercontent.com/u/75026773?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/ShIKULJAK',
  html_url: 'https://github.com/ShIKULJAK',
  followers_url: 'https://api.github.com/users/ShIKULJAK/followers',
  following_url:
    'https://api.github.com/users/ShIKULJAK/following{/other_user}',
  gists_url: 'https://api.github.com/users/ShIKULJAK/gists{/gist_id}',
  starred_url: 'https://api.github.com/users/ShIKULJAK/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/ShIKULJAK/subscriptions',
  organizations_url: 'https://api.github.com/users/ShIKULJAK/orgs',
  repos_url: 'https://api.github.com/users/ShIKULJAK/repos',
  events_url: 'https://api.github.com/users/ShIKULJAK/events{/privacy}',
  received_events_url: 'https://api.github.com/users/ShIKULJAK/received_events',
  type: 'User',
  site_admin: false,
  name: null,
  company: null,
  blog: '',
  location: null,
  email: null,
  hireable: null,
  bio: null,
  twitter_username: null,
  public_repos: 14,
  public_gists: 0,
  followers: 0,
  following: 0,
  created_at: '2020-11-25T13:40:41Z',
  updated_at: '2022-06-06T18:43:53Z',
};
